export const CONSUMER_DEVICE_HISTORY = 'api/v1/consumers/{0}/assets?history=N&website-type=site-null';
export const LINK_PRODUCT = 'api/v1/consumers/{0}/assets/{1}/link';
export const UNLINK_PRODUCT = 'api/v1/consumers/{0}/assets/{1}/unlink?actionType=de-registration';
export const GET_JWT = 'accounts.getJWT';
